import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { ItemDetail } from "./ItemDetail";
import Loader from "./Loader";
import { CartContext } from "../context/CartContext";

const ItemDetailContent = ({ handleCartModal }) => {
  window.scrollTo(0, 0);
  const [itemDetail, setItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { idProducto } = useParams();
  const { items } = useContext(CartContext);

  useEffect(() => {
    // Buscamos el producto y forzamos que ambos IDs sean String para que coincidan
    const foundItem = items.find(
      (item) => String(item.id) === String(idProducto),
    );

    if (foundItem) {
      // PARCHE: Convertimos las imágenes de texto a lista antes de mandarlas al detalle
      const limpio = {
        ...foundItem,
        imagenes:
          typeof foundItem.imagenes === "string"
            ? JSON.parse(foundItem.imagenes || "[]")
            : foundItem.imagenes,
      };
      setItem(limpio);
    }
    setIsLoading(false);
  }, [idProducto, items]);

  if (isLoading) return <Loader />;
  if (!itemDetail)
    return (
      <div className="text-center mt-5">
        <h3>Producto no encontrado</h3>
      </div>
    );

  return (
    <div className="detalle tienda pe-md-3 ps-md-3">
      <ItemDetail onHandleCartModal={handleCartModal} itemDetail={itemDetail} />
    </div>
  );
};

export default ItemDetailContent;
